module.exports = __webpack_public_path__ + "c2d28bc37fa897fcc730801d318ccfda.pdf";